import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFastlaneComponent } from './simple-icons-fastlane.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFastlaneComponent ],
    exports:      [ SimpleIconsFastlaneComponent ],
    bootstrap:    []
})
export class SimpleIconsFastlaneModule {}
